// Original hypothetical decisions. A bias label does not determine a buy/sell action.
export const behaviorReview = {
  moduleId: 'behavior',
  title: '把感受、證據與決策程序分開',
  questions: [
    {
      id: 'behavior-old-high-price-anchor',
      lessonId: 'anchoring-bias',
      question: '一檔假想股票過去 52 週最高價為 164 元，現在 123 元。小程沒有看營運與估值，只說「比最高價打了七五折，一定很便宜」。哪個判斷較完整？',
      options: [
        '只要比高點低 25%，就能證明目前價格低於合理價值',
        '相對高點確實下跌 25%，但高點不是合理價值的保證，仍需重新檢查目前資料',
        '曾經到過 164 元，就能保證價格一定會回去',
      ],
      answer: 1,
      explanation: '123 ÷ 164−1＝−25%，這只回答價格距離某個歷史高點多遠。把高點直接當成合理價值，可能受到錨定影響；公司前景、現金流、風險及估值假設都可能改變。檢查錨定並不代表應反向操作，而是避免只用一個醒目的數字替決策下結論。',
    },
    {
      id: 'behavior-loss-feeling-and-cash-need',
      lessonId: 'loss-aversion',
      question: '小恩原先多年後才需用的投資部位，從 60,000 元跌到 54,000 元，現在家中付款日期改為 30 天後。她唯一的理由是「賣出就像承認失敗，所以先不管付款」。哪個檢查方式較合理？',
      options: [
        '分開記下不願認賠的感受與 30 天後的資金需求，再核對可用現金、部位風險與選項',
        '只要有帳面虧損，就應立刻全部賣出，不必看資金需求或其他資訊',
        '未賣出就沒有任何經濟損失，因此可以忽略付款日期的改變',
      ],
      answer: 0,
      explanation: '不願承認損失可能讓人拖延評估，但付款時點改變本身就是需要重新檢視的事實。應分清情緒、資金期限與可承受風險；未實現損失仍反映當時市場價值的下降。這個情境不足以指定應買或賣多少，辨認偏誤也不是「遇到虧損就一律賣出」的規則。',
    },
    {
      id: 'behavior-trading-costs-and-confidence',
      lessonId: 'overconfidence-trading',
      question: '假想帳戶期初 100,000 元，期間無追加或提領；完成 40 趟交易，每趟買賣合計成本固定 90 元。全部交易的費前損益合計為獲利 5,200 元，無其他費稅。小豪因最後連續幾趟獲利，就認定自己有穩定優勢。哪個說法正確？',
      options: [
        '淨報酬為 5.2%，成本與評估交易能力無關',
        '只要最後幾趟連續獲利，就已排除運氣與市場因素',
        '扣費後淨利為 1,600 元、期間報酬為 1.6%；短期連勝仍不足以證明穩定優勢',
      ],
      answer: 2,
      explanation: '成本＝40×90＝3,600 元；淨利＝5,200−3,600＝1,600 元，除以期初 100,000 元為期間報酬 1.6%，不是年化報酬。評估能力還要看完整損益、風險、比較基準與足夠的觀察資料，不能只挑最近的贏家。交易較多不等於判斷較好，也不能反過來認定每筆交易都沒有合理目的。',
    },
    {
      id: 'behavior-journal-preserve-original-reason',
      lessonId: 'decision-journal',
      question: '小雅事前在日誌寫下「預期下一季營收年增 18%，因此開始研究這家公司」。發布後實際年減 6%，同期股價卻上漲 7%。她想把原紀錄改成「我早知道股價會漲」。哪種後續紀錄最有助於檢查判斷？',
      options: [
        '股價上漲已證明原本的營收預期正確，直接把原紀錄改成成功預測',
        '保留有日期的原假設，另記實際結果、落差原因與待查事項，把股價結果和推論品質分開檢查',
        '營收預測錯過一次，就不必再看其他資料，所有投資判斷都一定無效',
      ],
      answer: 1,
      explanation: '事前預期與後來公布的營收數字不一致，股價上漲不能替原假設補上證據。保留原始版本，再追加查證與修正理由，才看得見當時知道什麼、漏看什麼，以及哪些結果仍無法解釋。日誌用來檢查程序，不是只收集成功故事；一次結果也不足以替整體能力定論。',
    },
  ],
};
